import { useMemo } from 'react'
import {
  getTrackingRestrictedCompanyIds,
  ROUTES,
  VAPermissions,
} from '../Utils/constants'
import { t } from 'i18next'
import orderTrackingIcon from 'Assets/Images/Navbar/orderTracking.svg'
import searchOrderIcon from 'Assets/Images/Navbar/search.svg'
import dashboardTrackingIcon from 'Assets/Images/Navbar/dashboard.svg'
import settingsIcon from 'Assets/Images/Navbar/settings.svg'
import yappyIcon from 'Assets/Images/Navbar/yappy.svg'
import displayIcon from 'Assets/Images/Navbar/display.svg'
import { useSelector } from 'react-redux'
import useValidatePermission from 'Hooks/useValidatePermission'

// IDs de compañías que tienen restricción de tracking
const TRACKING_RESTRICTED_COMPANY_IDS = getTrackingRestrictedCompanyIds()

const useHandleElements = ({ defaultElements }) => {
  const companyId = useSelector(state => state.company.CompanyId)
  const hasSettingsPermission = useValidatePermission(VAPermissions.settingsVA)

  // Verificar si la compañía actual tiene acceso al tracking
  const hasTrackingAccess = useMemo(
    () => !TRACKING_RESTRICTED_COMPANY_IDS.includes(companyId),
    [companyId]
  )

  return useMemo(() => {
    const baseElements = [...defaultElements]

    if (hasTrackingAccess) {
      const alreadyIncluded = baseElements.some(
        el => el.title === t('DISPATCH_ORDER_T.ORDER_TRACKING')
      )
      if (!alreadyIncluded) {
        const newElement = {
          title: t('DISPATCH_ORDER_T.ORDER_TRACKING'),
          image: orderTrackingIcon,
          id: 'order-tracking',
          children: [
            {
              grandChildren: [
                {
                  title: 'Búsqueda de pedidos',
                  image: searchOrderIcon,
                  link: ROUTES.orderTracking,
                  id: 'search-orders',
                },
                {
                  title: 'Panel de Control',
                  image: dashboardTrackingIcon,
                  link: ROUTES.dashboardTracking,
                  id: 'dashboard-tracking',
                },
              ],
            },
          ],
        }
        const insertIndex = baseElements.findIndex(
          el => el.title === 'Clientes'
        )
        if (insertIndex === -1) {
          baseElements.push(newElement)
        } else {
          baseElements.splice(insertIndex, 0, newElement)
        }
      }
    }

    if (hasSettingsPermission) {
      const alreadyIncluded = baseElements.some(el => el.id === 'settings')
      if (!alreadyIncluded) {
        const children = [
          {
            title: t('SETTINGS_T.PAYMENT_METHODS'),
            grandChildren: [
              {
                title: t('SETTINGS_T.YAPPY'),
                image: yappyIcon,
                link: ROUTES.yappyConfig,
                id: 'yappy',
              },
            ],
          },
          {
            title: t('SETTINGS_T.CUSTOMER_DISPLAY.MENU'),
            grandChildren: [
              {
                title: t('SETTINGS_T.CUSTOMER_DISPLAY.SUB_MENU'),
                image: displayIcon,
                link: ROUTES.customerDisplaySettings,
                id: 'customerDisplay',
              },
            ],
          },
        ]
        baseElements.push({
          title: t('SETTINGS_T.TITLE'),
          image: settingsIcon,
          id: 'settings',
          children,
        })
      }
    }

    return baseElements
  }, [defaultElements, hasTrackingAccess, hasSettingsPermission])
}

export default useHandleElements
